@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;

  @include respond-to('sm') {
    flex-direction: row;
    gap: 40px;
  }
}

.dateSpan {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  margin-right: 12px;
}

.styledPriceDisplay {
  [data-price] {
    @include typography-v2-title-base;
  }
}

.primary[data-observation="true"] {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.countrySeries {
  @include typography-v2-body-sm;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  max-width: 640px;
}
